import { Button, Container, Group, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import classes from './styles.module.css';

export const ApplicationError = () => {
  const { t } = useTranslation();
  return (
    <div className={classes.root}>
      <Container data-testid='application-error'>
        <div className={classes.inner}>
          <Title className={classes.image} role='presentation'>
            {t('app.applicationError.oops')}
          </Title>
          <div className={classes.content}>
            <Title className={classes.title}>
              {t('app.applicationError.somethingWentWrong')}
            </Title>
            <Text size='lg' ta='center' className={classes.description}>
              {t('app.applicationError.alreadyReported')}
            </Text>
            <Group justify='center'>
              <Button size='md' variant='white' component='a' href='/'>
                {t('app.applicationError.reloadPage')}
              </Button>
            </Group>
          </div>
        </div>
      </Container>
    </div>
  );
};

export * from './route-error';